export default "__VITE_ASSET__B5kPu1mg__"